<template>
    <!-- Layout inner -->
    <div class="layout-inner pg_content course_about">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">

          <template v-if="showLoader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>

          <template v-if="showPage">

            <template v-if="programGuide && programGuide.title">
              <program-guide-title :program-guide="programGuide"></program-guide-title>
            </template>

            <!-- Page content -->
            <div class="container-fluid flex-grow-1 pg_content_container">
              <div class="row result_row">

            		<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 thumbnail_container">
                  <div class="thumbnail_container_inner">
                    <img class="thumb_img"
                      v-if="programGuide.thumbnailURL"
                      :src="programGuide.thumbnailURL"
                      tabindex="0"
                      onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
            			  <div v-else class="default_thumb">
                      <span class="ic ic-degreeProgram"></span>
                    </div>
                  </div>
            		</div>

              	<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 entity_details">
                  <template v-if="showAlumniDataJobTitle">
                    <div class="val mb-1">
                      <div><strong>{{alumniData.topCareerTitle}}</strong></div>
                      <div><small>most popular alumni career</small></div>
                    </div>
                  </template>

              		<div v-if="showMedianIncome" class="row" :aria-label="'median income ' + currencyLabel + programGuide.medianIncomePerYear" tabindex="0">
                			<div class="label">{{medianIncomeLabel}}</div>
                			<div class="val" v-if="programGuide.medianIncomePerYear">
                				{{currencyLabel}} <span v-html="addCommaInNumber(programGuide.medianIncomePerYear)"></span>
                			</div>
                			<div class="val no_data" v-else>N/A</div>
              		</div>

              		<div v-if="showJobPostings" class="row" :aria-label="'job postings ' + programGuide.totalJobPostings" tabindex="0">
                			<div class="label">{{jobPostingsLabel}}</div>
                			<div class="val" v-if="programGuide.totalJobPostings">
                				<span v-html="addCommaInNumber(programGuide.totalJobPostings)"></span>
                			</div>
                			<div class="val no_data" v-else>N/A</div>
              		</div>

              		<div v-if="showGrowthRate" class="row" :aria-label="'growth rate ' + programGuide.growthRate" tabindex="0">
                			<div class="label">{{growthRateLabel}}</div>
                			<div class="val" v-if="programGuide.growthRate">{{programGuide.growthRate}}%</div>
                			<div class="val no_data" v-else>N/A</div>
              		</div>

                  <template v-if="showAlumniDataJobTitle">
                    <div>
                      <div class="float-right">
                        <span @click="navigateToCareerProspects" style="cursor: pointer; color: #0645AD;">more</span>
                      </div>
                    </div>
                  </template>

          		</div>

            </div>

              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 hd" style="margin-left: -10px; margin-bottom: 15px;">
                  <h2>Description</h2>
                  <span class="hd_bdr"></span>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div v-if="programGuide.description" v-html="programGuide.description"></div>
                  <div v-else class="no_data">
                    No description added
                  </div>
                </div>
              </div>

            </div>
            <!-- / Page content -->
            <template v-if="isRelatedProgram">
              <program-footer-navbar :pageTitle="'Introduction'" :returnTo="'programGuideRelatedPrograms'" :params="relatedProgramParams"></program-footer-navbar>
            </template>
            <template v-else>
              <program-footer-navbar :pageTitle="'Introduction'" :returnTo="'programGuideMenu'" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'programGuideAbout',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isRelatedProgram', 'relatedProgramParams', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      alumniData: {},
      programGuide: {},
      showPage: false,
      showLoader: true,
    }
  },
  async beforeMount () {
      this.alumniData = await this.loadProgramAlumniData(this.programGuideCode)
    },
  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadInstitutionPackage',
      'loadProgramAlumniData'
    ]),
    async loadProgramGuideInfo () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      this.showLoader = false
      this.showPage = true
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    },
    navigateToCareerProspects () {
      let routeParams = {
        code: this.code,
        cipCode: this.programGuide.cipCode,
        programGuideCode: this.programGuide.code,
        type: this.programGuide.type,
        isComingFromBookmark: this.isComingFromBookmark
      }
      let queryParams = {}
      if (this.isComingFromBookmark) {
        queryParams = {returnTo: this.returnTo, pageTitle: this.pageTitle}
      }
      return this.$router.push({name: 'programGuideCareerProspects', params: routeParams, query: queryParams})
    },
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages,
    }),
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    isStudentLogin () {
      let role = this.userObj.roles[0].role
      return (role === 'Student')
    },
    showMedianIncome () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.enabled
    },
    medianIncomeLabel () {
      const defaultLabel = 'median income'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.label || defaultLabel
    },

    showJobPostings () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.enabled
    },
    jobPostingsLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.label || defaultLabel
    },

    showGrowthRate () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.enabled
    },
    growthRateLabel () {
      const defaultLabel = 'growth rate'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.label || defaultLabel
    },
    showAlumniTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    showAlumniDataJobTitle () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && this.alumniData.topCareerTitle && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    currencyLabel () {
      return '$'
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideAbout.vue